import { IItem } from 'models/item';
import { TConcept } from 'types';
import { createBaseItemInteraction, BaseItemServiceParams } from './baseItemInteraction';

export type Vocabulary = {
  id: string;
  templateType: 'vocabulary';
  rawItem: IItem;
  updateRawItem: (newRawItem: IItem) => void;
  updateConceptLocally: (conceptId: string, updates: Partial<TConcept>) => void;
};

export default function vocabulary(params: BaseItemServiceParams): Vocabulary {
  return createBaseItemInteraction(params, 'vocabulary') as Vocabulary;
}